import React, { useEffect, useRef, useState } from 'react';
import UploadDocPopUp from './UploadDocPopUp';
import DocsGrid from './DocsGrid';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import { format } from 'date-fns';
import Pagination from '../../Utilities/Pagination';
import { Skeleton } from '@mui/material';
import Button from '../Button';
import { setSeltSerchPat } from '../../redux/slices/patient/patientSlice';
import { useDispatch } from 'react-redux';

function MainDocsScreen() {
  const [allData, setAllData] = useState(null);
  const [openAddEditPopup, setOpenAddEditPopup] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const dispatch = useDispatch();
  const selectRef = useRef();

  const [patName, setPatName] = useState('');
  const [docName, setDocName] = useState('');
  const [docsType, setDocsType] = useState('');
  const [docsStatus, setDocsStatus] = useState('');
  const [reviewer, setReviewer] = useState('');
  const [alocatToUser, setAlocatToUser] = useState('');
  const [provider, setProvider] = useState('');
  const [uploded, setUploded] = useState('TM');
  const [limit, setSetLimit] = useState(0);
  const [offset, setSetOfset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // const {
  //   patName,
  //   docName,
  //   docsType,
  //   docsStatus,
  //   reviewer,
  //   alocatToUser,
  //   provider,
  //   uploded,
  //   // limit,
  //   // offset,
  // } = manDocsGrid;
  const [reload, setReload] = useState(false);
  function handleReload() {
    setReload(!reload);
  }

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const response = await post(
          'api/patient/ManagePatientDocument/manageDocumentList',
          {
            patientId: '',
            patientName: patName,
            docName: docName,
            docType: docsType,
            status: docsStatus,
            reviewer: reviewer,
            allocateTo: alocatToUser,
            provider: provider,
            dateFilter: uploded,
            limit: limit,
            offset: offset,
          }
        );
        if (response?.status === 200) {
          setAllData(response?.data);
          setTotalRecord(Number(response?.data.documentCount || 0));
        }
      } catch (e) {
        setUiMessage('err', e.message);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [
    alocatToUser,
    docName,
    docsStatus,
    docsType,
    patName,
    provider,
    reviewer,
    reload,
    uploded,
    limit,
    offset,
  ]);

  const handleChange = (date) => {
    const formattedDate = format(date, DEFAULT_DATE_FORMATE);
    selectRef.current.value = formattedDate;
    selectRef.current.text = formattedDate;
    selectRef.current.classList.remove('hide');
    setUploded(formattedDate);
  };

  return (
    <div className="docMaingrid-Pat  doc-main-grid">
      <div className="c-mid-bdy-hdr clear-top10 flex-sec justify-between item-center">
        <div className="widget-hdr-title bold clear-top">Documents:</div>
        <Button
          variant="primary"
          className=""
          onClick={() => {
            setOpenAddEditPopup(true);
            dispatch(setSeltSerchPat({}));
          }}
        >
          Add New
        </Button>
        {/* <span className="actn-yes center" style={{ width: '12%' }}>
          Add New
        </span> */}
        {openAddEditPopup && (
          <UploadDocPopUp
            close={() => setOpenAddEditPopup(false)}
            handleReload={handleReload}
          />
        )}
      </div>
      <div
        className="flex-sec justify-between item-center"
        style={{ padding: '3px 0px' }}
      >
        <div className="flex-sec">
          <div className="flex-sec">
            <span className="doc-hdr-lbl">Uploaded:</span>
            <span className="doc-hdr-val">
              <select
                className="inpt-width-nw"
                onChange={(e) => {
                  setUploded(e.target.value);
                  selectRef.current.value = '';
                  selectRef.current.text = '';
                  selectRef.current.classList.add('hide');
                }}
                value={uploded || ''}
              >
                <option value="TD">Today</option>
                <option value="YD">Yesterday</option>
                <option value="TW">This Week</option>
                <option value="LW">Last Week</option>
                <option value="TM">This Month</option>
                <option value="LM">Last Month</option>
                <option value="ALL">All</option>
                <option ref={selectRef} className="hide" value=""></option>
              </select>
            </span>
          </div>
          <div className="flex-sec" style={{ margin: '4px 0px 0px -11px' }}>
            <ReactDatePicker
              selected={new Date()}
              onChange={(date) => handleChange(date)}
              customInput={
                <img
                  src={'./images/calendar-icon.png'}
                  alt="Calendar"
                  width={'30px'}
                />
              } // Use the image as the custom input
              dateFormat={DEFAULT_DATE_FORMATE}
            />
          </div>
          <div className="flex-sec">
            <span className="doc-hdr-lbl">Type:</span>
            <span className="doc-hdr-val">
              <select
                className="inpt-width-nw"
                value={docsType || ''}
                onChange={(e) => {
                  setDocsType(e.target.value);
                }}
              >
                <option value="">Select</option>
                {allData?.patientDistDocTypeArray?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
          </div>
          <div className="flex-sec">
            <span className="doc-hdr-lbl">Status:</span>
            <span className="doc-hdr-val">
              <select
                className="inpt-width-nw"
                value={docsStatus || ''}
                onChange={(e) => {
                  setDocsStatus(e.target.value);
                }}
              >
                <option value="">Select</option>
                {allData?.statusList?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
          </div>
          <div className="flex-sec">
            <span className="doc-hdr-lbl">Provider:</span>
            <span className="doc-hdr-val">
              <select
                className="inpt-width-nw"
                value={provider || ''}
                onChange={(e) => {
                  setProvider(e.target.value);
                }}
              >
                <option value="">Select</option>
                {allData?.providerArray?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
          </div>
        </div>
        <Pagination
          totalRecord={totalRecord}
          onPageChange={(data) => {
            setSetLimit(data[1]);
            setSetOfset(data[0]);
          }}
          offset={offset}
          rowPerPage={200}
        />
      </div>
      <div className="docMaingrid-Patbdy grid-sec">
        <div className="docMaingrid-Pat-hdr grid-sec">
          <div className="docMaingrid-Pat-sbhdr flex-sec">
            <span className="colm3"></span>
            <span className="colm1">Name</span>
            <span className="colm1">Doc Name</span>
            <span className="colm1">Type</span>
            <span className="colm2">Date</span>
            <span className="colm5">Status</span>
            <span className="colm4">Action</span>
            <span className="colm1">Reviewer</span>
            <span className="colm3 note-col">Note</span>
            <span className="colm3">Pages</span>
            <span className="colm1">Allocated to</span>
            <span className="colm1">Provider</span>
            <span className="colm2">Added</span>
          </div>
          <div className="docMaingrid-Pat-sbhdr flex-sec">
            <span className="colm3"></span>
            <span className="colm1">
              <input
                type="search"
                className="inpt-width-nw"
                value={patName || ''}
                onChange={(e) => {
                  setPatName(e.target.value);
                }}
              />
            </span>
            <span className="colm1">
              <input
                type="search"
                className="inpt-width-nw"
                value={docName || ''}
                onChange={(e) => {
                  setDocName(e.target.value);
                }}
              />
            </span>
            <span className="colm1">
              <select
                className="inpt-width-nw"
                value={docsType || ''}
                onChange={(e) => {
                  setDocsType(e.target.value);
                }}
              >
                <option value="">Select</option>
                {allData?.patientDistDocTypeArray?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
            <span className="colm2"></span>
            <span className="colm5">
              <select
                className="inpt-width-nw"
                value={docsStatus || ''}
                onChange={(e) => {
                  setDocsStatus(e.target.value);
                }}
              >
                <option value="">Select</option>
                {allData?.statusList?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
            <span className="colm4"></span>
            <span className="colm1">
              <select
                className="inpt-width-nw"
                value={reviewer || ''}
                onChange={(e) => {
                  setReviewer(e.target.value);
                }}
              >
                <option value="">Select</option>
                {allData?.reviewerArray?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
            <span className="colm3 note-col"></span>
            <span className="colm3"></span>
            <span className="colm1">
              <select
                className="inpt-width-nw"
                value={alocatToUser || ''}
                onChange={(e) => {
                  setAlocatToUser(e.target.value);
                }}
              >
                <option value="">Select</option>
                {allData?.assoUserArray?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
            <span className="colm1">
              <select
                className="inpt-width-nw"
                value={provider || ''}
                onChange={(e) => {
                  setProvider(e.target.value);
                }}
              >
                <option value="">Select</option>
                {allData?.providerArray?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
            <span className="colm2"></span>
          </div>
        </div>
        {isLoading ? (
          <Skeleton />
        ) : allData?.documentDetailArr &&
          allData?.documentDetailArr.length > 0 ? (
          allData?.documentDetailArr?.map((item, i) => (
            <DocsGrid
              key={i}
              item={item}
              index={i}
              handleReload={handleReload}
            />
          ))
        ) : (
          <p className="no-appoinmnts-here">No record found. !!</p>
        )}
      </div>
    </div>
  );
}

export default MainDocsScreen;
